import React from "react";
import QcContainer from "../containers/Qc";

const Qc = () => {
  return <QcContainer />;
  // return <></>
};

export default Qc;
